export type GetUserRolesResponse = {
  userRoles: UserRoleInfo[];
};

export type UserRoleInfo = {
  userId: string;
  emplyNum: string;
  userName: string;
  mlAdrs: string;
  delFlg: string;
  roleCd: string;
  roleName: string;
  cvrgCd: string;
  primFlg: string;
  updateDateTime: string;
};
